import { render, staticRenderFns } from "./customer-view.vue?vue&type=template&id=3f424c6e&scoped=true&"
import script from "./customer-view.vue?vue&type=script&lang=ts&"
export * from "./customer-view.vue?vue&type=script&lang=ts&"
import style0 from "./customer-view.vue?vue&type=style&index=0&id=3f424c6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f424c6e",
  null
  
)

export default component.exports